/* eslint-disable no-else-return */
export const emptyObject = {};
export const emptyFunc = () => {};

function add(target, obj) {
  if (obj) {
    Object.keys(obj).forEach((key) => {
      const value = obj[key];
      if (value !== null && value !== undefined) {
        // eslint-disable-next-line no-param-reassign
        target[key] = value;
      }
    });
  }
}

function isEmpty(value) {
  if (Array.isArray(value)) {
    return value.length === 0;
  } else {
    return Object.keys(value).length === 0;
  }
}

export function merge(objA, objB) {
  const result = {};
  add(result, objA);
  add(result, objB);
  return result;
}

export function parsePath(path) {
  const result = [];

  if (!path) {
    return result;
  }

  let part = "";
  for (let i = 0, len = path.length; i < len; i++) {
    const c = path[i];
    switch (c) {
      case ".": {
        if (part) {
          result.push({
            type: "object",
            value: part,
          });
          part = "";
        }
        break;
      }
      case "[": {
        if (part) {
          result.push({
            type: "array",
            value: part,
          });
          part = "";
        }
        break;
      }
      case "]": {
        if (part) {
          result.push({
            type: "object",
            value: Number(part),
          });
          part = "";
        }
        break;
      }
      default: {
        part += c;
      }
    }
  }

  if (part) {
    result.push({
      type: "object",
      value: part,
    });
  }

  return result;
}

export function getValueByPath(object, parsedPath) {
  if (!object) {
    return undefined;
  }

  let result = object;
  for (let i = 0; i < parsedPath.length; i++) {
    result = result[parsedPath[i].value];
    if (result === undefined) {
      return undefined;
    }
  }

  return result;
}

export function setValueByPath(object, parsedPath, value) {
  const result = { ...object };
  let current = result;
  for (let i = 0; i < parsedPath.length; i++) {
    const pathItem = parsedPath[i];
    if (i === parsedPath.length - 1) {
      current[pathItem.value] = value;
    } else {
      let item = current[pathItem.value];
      if (pathItem.type === "array") {
        item = item ? [...item] : [];
      } else {
        item = item ? { ...item } : {};
      }
      current[pathItem.value] = item;
      current = item;
    }
  }

  if (value === undefined) {
    const valuesPath = [];
    let curValue = result;
    for (let i = 0; i < parsedPath.length; i++) {
      valuesPath.push(curValue);
      curValue = curValue[parsedPath[i].value];
      if (!curValue) {
        break;
      }
    }
    for (let i = valuesPath.length - 1; i > -1; i--) {
      const pathItem = parsedPath[i];
      if (Array.isArray(valuesPath[i])) {
        valuesPath[i].splice(pathItem.value, 1);
      } else {
        delete valuesPath[i][pathItem.value];
      }
      if (!isEmpty(valuesPath[i])) {
        break;
      }
    }
  }

  return result;
}
